import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import rte, {command} from '../rte.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import closest from "@mailobj-browser/front/js/selectors/closest.js"
import one from "@mailobj-browser/front/js/selectors/one.js"

const onClick = object(listener, {
  type: click,
  hooks: array([
    preventDefault
  ]),
  task: (
    button
  ) => {
    const form = closest('form', button)
    const rte = one('iframe[data-rte]', form)

    if (rte && rte.id) {
      command(rte.id, 'justifyright', '')
    }
  }
})

export const highlight = (
  button,
  modifier,
  text
) => {
  if (closest('[style*="text-align: right"]', text)) {
    button.classList.add(modifier)
  }
}

export default button => {
  onClick.listen(button)
  rte(button, object(null, { highlight }))
}
